var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagEu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 51,
  height: 35,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#flag-eu_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#039",
  d: "M50.78.577h-50v34h50z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m25.78 4.354-.572 1.797.881.292z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m25.78 4.354.573 1.797-.88.292z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m27.543 5.66-1.848.008-.004.936z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "M27.543 5.655 26.04 6.77l-.54-.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m26.87 7.769-.57-1.794-.883.294z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m26.867 7.771-1.495-1.107.546-.767z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m24.02 5.66 1.848.008.004.936z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m24.02 5.655 1.502 1.115.54-.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m24.693 7.769.569-1.794.884.294z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m24.695 7.771 1.496-1.107-.547-.767zM25.78 27.021l-.572 1.796.881.292z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m25.78 27.021.573 1.796-.88.292z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m27.543 28.326-1.848.009-.004.936z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m27.543 28.322-1.503 1.114-.54-.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m26.87 30.436-.57-1.794-.883.294z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m26.867 30.438-1.495-1.107.546-.767z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m24.02 28.326 1.848.009.004.936z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m24.02 28.322 1.502 1.114.54-.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m24.693 30.436.569-1.794.884.294z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m24.695 30.438 1.496-1.107-.547-.767zM14.67 15.688l-.573 1.796.88.292z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m14.67 15.688.572 1.796-.88.292z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m16.431 16.993-1.847.009-.005.935z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m16.431 16.988-1.502 1.115-.54-.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m15.758 19.102-.568-1.794-.885.295z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m15.756 19.105-1.496-1.108.547-.767z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m12.909 16.993 1.847.009.005.935z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m12.909 16.988 1.502 1.115.54-.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m13.582 19.102.568-1.794.884.295z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m13.584 19.105 1.496-1.108-.547-.767zM19.14 9.29l1.495-1.108-.547-.767z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m19.137 9.287.569-1.794.884.295z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m18.464 7.175 1.5 1.113.543-.762z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m18.464 7.178 1.85.005.002.94z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m20.222 5.873-.569 1.794.885.294z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m20.222 5.873.576 1.799-.877.289z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m21.315 9.29-1.5-1.113.542-.762z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m21.314 9.292-.576-1.799-.877.29z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "M21.986 7.18 20.49 8.288l-.546-.766z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m21.984 7.182-1.85-.004.002.94zM17.247 13.435l-.569-1.793-.884.294z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m17.244 13.438-1.495-1.107.546-.767z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m15.068 13.438 1.5-1.113-.541-.761z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m15.07 13.44.576-1.799.877.29z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m14.398 11.328 1.496 1.108.546-.766z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m14.4 11.33 1.85-.004-.003.94z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m17.92 11.324-1.5 1.112-.543-.761z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m17.92 11.326-1.85.005-.002.94z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m16.162 10.021.568 1.794-.884.294z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m16.162 10.021-.576 1.799.877.29zM17.92 22.66l-1.846.012-.006.932z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m17.92 22.653-1.504 1.117-.539-.758z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m17.247 24.765-.563-1.79-.89.298z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m17.24 24.771-1.49-1.102.55-.772z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m15.066 24.771 1.502-1.114-.54-.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m15.07 24.776.578-1.801.875.288z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m16.167 21.354.564 1.791-.888.298z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m16.166 21.354-.58 1.803.873.286z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m14.4 22.665 1.85-.005-.003.939z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m14.398 22.662 1.495 1.108.547-.767zM21.987 26.808l-1.846.012-.006.932z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m21.987 26.801-1.504 1.117-.539-.758z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m21.314 28.913-.563-1.79-.89.299z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m21.308 28.92-1.492-1.103.55-.772z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m19.133 28.92 1.502-1.115-.54-.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m19.137 28.924.578-1.8.875.287z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m20.233 25.503.565 1.79-.888.298z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m20.233 25.503-.58 1.802.873.286z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m18.467 26.813 1.85-.005-.003.94z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m18.464 26.81 1.496 1.108.547-.767zM36.893 15.688l.572 1.796-.88.292z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m36.893 15.688-.573 1.796.88.292z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m35.13 16.993 1.848.009.005.935z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m35.13 16.988 1.503 1.115.54-.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m35.804 19.102.569-1.794.884.295z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m35.806 19.105 1.496-1.108-.547-.767z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m38.653 16.993-1.847.009-.005.935z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m38.653 16.988-1.502 1.115-.54-.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m37.98 19.102-.568-1.794-.884.295z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m37.978 19.105-1.496-1.108.547-.767zM32.422 9.29l-1.495-1.108.547-.767z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m32.425 9.287-.569-1.794-.884.295z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m33.098 7.175-1.5 1.113-.543-.762z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m33.098 7.178-1.85.005-.002.94z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m31.34 5.873.569 1.794-.885.294z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m31.34 5.873-.576 1.799.877.289z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m30.247 9.29 1.5-1.113-.542-.762z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m30.249 9.292.575-1.799.877.29z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m29.576 7.18 1.496 1.108.546-.766z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m29.578 7.182 1.85-.004-.002.94zM34.315 13.435l.569-1.793.884.294z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m34.318 13.438 1.495-1.107-.546-.767z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m36.494 13.438-1.5-1.113.541-.761z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m36.492 13.44-.576-1.799-.877.29z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m37.165 11.328-1.497 1.108-.546-.766z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m37.163 11.33-1.85-.004.002.94z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m33.643 11.324 1.5 1.112.542-.761z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m33.643 11.326 1.85.005.001.94z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m35.4 10.021-.568 1.794.884.294z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m35.4 10.021.576 1.799-.877.29zM33.642 22.66l1.846.012.006.932z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m33.642 22.653 1.504 1.117.538-.758z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m34.315 24.765.563-1.79.89.298z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m34.321 24.771 1.492-1.102-.55-.772z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m36.496 24.771-1.502-1.114.54-.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m36.492 24.776-.578-1.801-.875.288z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m35.396 21.354-.565 1.791.888.298z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m35.396 21.354.58 1.803-.873.286z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m37.162 22.665-1.85-.005.003.939z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m37.165 22.662-1.496 1.108-.547-.767zM29.575 26.808l1.846.012.006.932z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m29.575 26.801 1.504 1.117.539-.758z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m30.248 28.913.563-1.79.89.299z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m30.254 28.92 1.492-1.103-.55-.772z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m32.43 28.92-1.503-1.115.54-.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m32.425 28.924-.578-1.8-.875.287z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m31.329 25.503-.565 1.79.889.298z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m31.33 25.503.579 1.802-.873.286z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m33.095 26.813-1.85-.005.003.94z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m33.098 26.81-1.496 1.108-.547-.767z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "flag-eu_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.78.577h50v34h-50z"
})))));
export default SvgFlagEu;